import gsap from 'gsap'
import {useGSAP} from '@gsap/react'
import {useRef} from 'react'

export default function GParallax({speed = 1, scrollTrigger = {}, options = {}, to = {}, ...props}) {
  const wrapperRef = useRef(null)

  useGSAP(() => {
    gsap.fromTo(wrapperRef.current, {
      //ease: '',
      y: speed * 3 + "%",
      //scale: 1.05,
      ...options
    }, {
      y: -speed * 3 + "%",
      scrollTrigger: {
        ease: 'none',
        trigger: wrapperRef.current,
        scrub: 2,
        start: 'top 100%',
        end: '100% 0%',
        invalidateOnRefresh: true,
        ...scrollTrigger
      },
      ...to
    })
  })

  props.className = `parallax-wrapper ${props.className || ''}`.trim()

  return (
    <div ref={wrapperRef} {...props}>
      {props.children}
    </div>
  )
}